var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 10.16,
    y1: 56.5,
    x2: 102.84,
    y2: 56.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a02d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5b73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 47.6,
    y1: 1412.45,
    x2: 70.95,
    y2: 1365.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1434)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.45,97.66a24.67,24.67,0,0,0-10-4.73A21.2,21.2,0,0,1,10.16,72.32V22A21.18,21.18,0,0,1,31.34.82H81.66A21.18,21.18,0,0,1,102.84,22V72.32A21.2,21.2,0,0,1,86.51,92.93a24.67,24.67,0,0,0-10,4.73L60.46,110.77a6.27,6.27,0,0,1-7.92,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,10.2H81.66A11.8,11.8,0,0,1,93.46,22V72.32a11.8,11.8,0,0,1-11.8,11.8H31.34a11.8,11.8,0,0,1-11.8-11.8V22.17a12,12,0,0,1,12-12Z",
    fill: "url(#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.49,14.88A23.77,23.77,0,0,1,79.82,33.57a24.27,24.27,0,0,1-1.25,14.17A84.6,84.6,0,0,1,65.85,70.16a61.11,61.11,0,0,1-8.94,9.11.57.57,0,0,1-.79.07.46.46,0,0,0-.07-.07,54.63,54.63,0,0,1-7.77-7.51A77.22,77.22,0,0,1,33.89,46.22a23.78,23.78,0,0,1,22.6-31.34Z",
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,33.74A23.25,23.25,0,0,0,56.49,15.28a22.94,22.94,0,0,0-11.14,2.85,23.51,23.51,0,0,0-10.88,28,76.78,76.78,0,0,0,14,25.23A54.32,54.32,0,0,0,56,78.9a.56.56,0,0,0,.79.06l.06-.06a60.55,60.55,0,0,0,8.76-9A84.31,84.31,0,0,0,78,47.77,24.3,24.3,0,0,0,79.2,33.74ZM56.39,52.93A14.25,14.25,0,1,1,70.58,38.61v.09A14.24,14.24,0,0,1,56.39,52.93Z",
    fill: "url(#linear-gradient-2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/Generic.3122cf208f3cb7f799cd921e163c02b0.svg";
export { ForwardRef as ReactComponent };